import {cleaningTypeLabel} from '../service/JobTypeService';
import ImportantAcknowledgement from "./ImportantAcknowledgement";
import {Card, Col, Collapse, Container, Row} from "react-bootstrap";
import {convertDescriptionPrefix, determinBorder, determinColor, getDisplayStatus} from "../service/jobutil";
import UpdateButtonMenu from "./UpdateJobButtonMenu";
import {useState} from "react";
import JobImageGallary from "./JobImageGallary";
import {ParkingFee} from "./parkingfee/ParkingFee";
import {CopyAddress} from "./CopyAddress";
import {ExtraCleaningFee} from "./ExtraCleaningFee";
import {CheckList} from "./checklist/CheckList";
import {ChecklistStatus} from "./checklist/ChecklistStatus";
import {PropertyIssue} from "./propertyissue/PropertyIssue";
import JobSourceBadge from "./JobSourceBadge";
import {SCHEDULER_BACKLOG_ZONE, setSchedulerDragData} from "./scheduler/schedulerDragDrop";
import BlockedAgencyIcon, {BLOCKED_AGENCY_MESSAGE} from "./scheduler/BlockedAgencyIcon";
import JobPropertyChatButton from "./chat/JobPropertyChatButton";
import JobComplaintButton from "./jobcomplaint/JobComplaintButton";

function JobCardTitle({job, showBlockedAgency}) {
    const leadingTitle = [job.full_address, job.key_number].filter(Boolean).join(", ");

    return (
        <b data-testid="job-card-title" style={{marginLeft: "8px"}}>
            {leadingTitle}
            {leadingTitle && job.agent_name ? ", " : ""}
            {job.agent_name || ""}
            {showBlockedAgency ? <BlockedAgencyIcon /> : null}
            {`, CheckOut:${job.check_out || ""}`}
            {job.check_in ? `, CheckIn:${job.check_in}` : ""}
        </b>
    );
}


export default function JobCardList({
                                        job,
                                        fieldWorkerMap,
                                        fieldSupervisorMap,
                                        isLoading,
                                        onEditJob,
                                        onJobUpdated,
                                        onIssueSummaryChanged,
                                        dragSourceZone,
                                        isAgencyBlocked = false,
                                        mobileAction = null,
                                        cleanerHint = null,
                                        onAssignCleaner,
                                    }) {

    const [open, setOpen] = useState(false);
    const [images, setImages] = useState([])
    const isBlockedBacklogCard = isAgencyBlocked && dragSourceZone === SCHEDULER_BACKLOG_ZONE;
    const isDragDisabled = isLoading || isBlockedBacklogCard;
    return (
        <div style={{marginBottom: "3px"}}>
            <Container fluid>
                <Row>
                    <Col>
                        <Card style={{
                                  textAlign: "left",
                                  userSelect: "text",
                                  cursor: isBlockedBacklogCard ? "not-allowed" : undefined,
                              }}
                              draggable={!isDragDisabled}
                              title={isBlockedBacklogCard ? BLOCKED_AGENCY_MESSAGE : undefined}
                              onDragStart={(event) => setSchedulerDragData(event, job.cos_job_id, dragSourceZone)}
                              border={determinBorder(job)}>

                            <Card.Body>
                                <div onClick={() => setOpen(!open)}>
                                    <div className="job-card-title-row" style={{display: "flex"}}>
                                          <span className="job-card-title-content">
                                            <JobCardTitle job={job} showBlockedAgency={isBlockedBacklogCard} />
                                            {job.tags && job.tags.includes("B2B_NEW") ? (
                                                <span style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#fff",
                                                    color: "red",
                                                    border: "1.5px solid red",
                                                    borderRadius: "4px",
                                                    padding: "2px 8px",
                                                    fontSize: "0.85em",
                                                    fontWeight: 600,
                                                    marginLeft: "8px",
                                                    marginRight: "4px",
                                                    verticalAlign: "middle"
                                                }}>B2B_NEW</span>
                                            ) : job.check_in ? (
                                                <span style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#fff",
                                                    color: determinColor(job),
                                                    border: `1.5px solid ${determinColor(job)}`,
                                                    borderRadius: "4px",
                                                    padding: "2px 8px",
                                                    fontSize: "0.85em",
                                                    fontWeight: 600,
                                                    marginLeft: "8px",
                                                    marginRight: "4px",
                                                    verticalAlign: "middle"
                                                }}>B2B</span>
                                            ) : null}
                                            <CopyAddress job={job}/>
                                          </span>
                                        <span className="job-card-status" style={{
                                            marginLeft: "auto", color: determinColor(job)
                                        }}><b>{getDisplayStatus(job)}</b><ImportantAcknowledgement job={job} onUpdated={onJobUpdated} disabled={isLoading}/></span>
                                    </div>
                                    <div className="job-card-metadata-row" style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                                        <span className="job-id-source-cell" style={{flex: 1}}>
                                            <JobSourceBadge job={job} compact/>
                                            <span>{cleaningTypeLabel(job)}</span>
                                            <span><b>Job ID:</b> {job.cos_job_id}</span>
                                        </span>

                                        <div className="job-card-fees" style={{flex: 1, display: "flex", justifyContent: "center"}}>
                                            <div style={{display: "flex", alignItems: "center"}}>
                                                <ParkingFee job={job}/>
                                                <ExtraCleaningFee job={job}/>
                                                <CheckList job={job} fieldSupervisorMap={fieldSupervisorMap}
                                                           fieldWorkerMap={fieldWorkerMap}/>
                                                <ChecklistStatus job={job} onJobUpdated={onJobUpdated}/>
                                                <PropertyIssue job={job} onIssueSummaryChanged={onIssueSummaryChanged}/>
                                                <JobPropertyChatButton job={job}/>
                                                <JobComplaintButton job={job}/>
                                            </div>
                                        </div>
                                        <span className="job-card-date" style={{flex: 1, textAlign: "right"}}>
                                            <span className="job-card-date-value">Date: {job.date}</span>
                                            {mobileAction ? (
                                                <span className="scheduler-mobile-inline-action">
                                                    {mobileAction}
                                                </span>
                                            ) : null}
                                        </span>
                                    </div>
                                    <div className="job-card-assignment-row" style={{display: "flex", justifyContent: "space-between", width: "100%"}}>


                                        <span className="job-card-supervisor" style={{
                                            flex: 1, textAlign: "left"
                                        }}><b>Supervisor: </b>{fieldSupervisorMap[job.cos_job_supervisor] ? fieldSupervisorMap[job.cos_job_supervisor] : 'None'}</span>
                                        <span className="job-card-worker" style={{
                                            flex: 1, textAlign: "right"
                                        }}><b>Worker: </b>{fieldWorkerMap[job.cos_job_worker] || ""}</span>
                                    </div>
                                    {cleanerHint ? (
                                        <div className="job-card-cleaner-row" style={{display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px", marginTop: "4px"}}>
                                            <span className={`badge ${cleanerHint.mode === "FIXED" ? "bg-primary" : "bg-secondary"}`}
                                                  title={cleanerHint.backupName ? `Backup: ${cleanerHint.backupName}` : undefined}>
                                                {cleanerHint.label}
                                            </span>
                                            {onAssignCleaner ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm py-0"
                                                    disabled={isLoading}
                                                    aria-label={`Assign ${job.cos_job_id} to ${cleanerHint.workerName}`}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        onAssignCleaner();
                                                    }}
                                                >
                                                    Assign
                                                </button>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                                <Collapse in={open}>
                                    <div>
                                        <div>
                                            <span>{convertDescriptionPrefix(job, true)}</span>
                                        </div>
                                        <div style={{marginTop: "20px"}}>
                                            <span>{job.description}</span>
                                        </div>

                                        <div style={{display: "flex", marginTop: "20px"}}>
                                <span>
                                    {job.email}<br/>
                                    {job.phone}</span>
                                            <span style={{marginLeft: "auto"}}>
                                        <UpdateButtonMenu row={job} onClick={onEditJob}/><br/>
                                    </span>
                                        </div>
                                        {open && <JobImageGallary job={job}
                                                                  images={images}
                                                                  isReadOnly={true}
                                                                  setImages={setImages}/>}

                                    </div>
                                </Collapse>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>


        </div>)
}
